import { useContext, useEffect, useMemo, useState } from "react"
import { ToastContext } from "../../../context/ToastContext"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { calculateWordsFromString, dateConvert } from "../../../utils/Helper";

export const useManagerChangeRequest = ({ userData }) => {

    const { showInfo, showSuccess } = useContext(ToastContext);
    const [fieldValues, setFieldValues] = useState({ reportingManager: null, remark: "", loader: false, gridLoader: false });
    const [rowData, setRowData] = useState([]);
    const columns = [
        {
            key: "repoter_name",
            label: "Reporter Name",
            style: { width: "20%" },
            render: (row) => <div className=" text-truncate" title={row?.repoter_name}>{row?.repoter_name}</div>
        },
        {
            key: "start_datetime",
            label: "Start Date",
            style: { width: "25%" },
            render: (row) => row?.start_datetime ? <div className=" text-truncate" title={dateConvert(row?.start_datetime, "date-time-months")}>{dateConvert(row?.start_datetime, "date-time-months")}</div> : ""
        },
        {
            key: "end_datetime",
            label: "End Date",
            style: { width: "25%" },
            render: (row) => row?.end_datetime ? <div className="text-truncate" title={dateConvert(row?.end_datetime, "date-time-months")}>{dateConvert(row?.end_datetime, "date-time-months")}</div> : ""
        },
        {
            key: "remark",
            label: "Remark",
            style: { width: "30%" },
            render: (row) => <div className=" text-truncate" title={row?.remark}>{row?.remark}</div>
        },
    ]

    useEffect(() => {
        GetManagerAllocation();
    }, [])

    const GetManagerAllocation = async () => {
        try {
            setFieldValues((prev) => ({ ...prev, gridLoader: true }));
            const payload = {
                employee_user_code: userData?.user_code
            }
            const res = await services.getInvokeRemote("POST", Urls("GETUSERREPORTINGMANAGERALLOCATION"), payload);
            if (res) {
                const data = res?.body?.data?.user_reporting_manager_allocation_list;
                setRowData(data);
                setFieldValues((prev) => ({ ...prev, gridLoader: false }));
            }
        } catch (error) {
            console.error("Error: ", error);
            setFieldValues((prev) => ({ ...prev, gridLoader: false }));
        }
    }

    const requestManagerChange = async () => {
        try {
            if (_.isEmpty(fieldValues?.reportingManager)) {
                showInfo("Info", "Please select reporting manager");
                return;
            } else if (calculateWordsFromString(fieldValues?.remark) < 5) {
                showInfo("Info", "Please enter remark of atleast 5 words");
                return;
            }
            setFieldValues((prev) => ({ ...prev, loader: true }))
            const payload = {
                requested_user_code: userData?.user_code || 0,
                manager_code: fieldValues?.reportingManager?.user_code || 0,
                remark: fieldValues?.remark
            }
            const res = await services.getInvokeRemote("POST", Urls("MANAGERCHANGEREQUEST"), payload);
            if (res) {
                showSuccess("Success", res?.body?.message)
                setFieldValues((prev) => ({ ...prev, reportingManager: null, remark: "", loader: false }));
                GetManagerAllocation();
            }
        } catch (error) {
            console.error("Error: ", error);
            setFieldValues((prev) => ({ ...prev, loader: false }))
        }
    }

    return useMemo(() => ({
        fieldValues, setFieldValues, requestManagerChange, columns, rowData
    }), [fieldValues, setFieldValues, requestManagerChange, columns, rowData])
}